export default "__VITE_ASSET__DmNfzBYq__"